export const DEVICE_PAGINATION = {
  LIMIT: 2000,
  EIGHT_HOURS_MS: 8 * 60 * 60 * 1000,
} as const;
